import { DataOwnerConfigDTO } from '../dto';
import { AssortmentConfig } from './AssortmentConfig';
import { LocationConfig } from './LocationConfig';

interface DataOwnerConfigProps {
  id: number;
  name: string;
  assortments: AssortmentConfig[];
  locations: LocationConfig[];
}

export class DataOwnerConfig {
  id: number;
  name: string;
  assortments: AssortmentConfig[];
  locations: LocationConfig[];

  constructor({ id, name, assortments, locations }: DataOwnerConfigProps) {
    this.id = id;
    this.name = name;
    this.assortments = assortments;
    this.locations = locations;
  }

  static fromDto = (dto: DataOwnerConfigDTO): DataOwnerConfig =>
    new DataOwnerConfig({
      id: dto.id || 0,
      name: dto.name || '',
      assortments: dto.assortments ? dto.assortments.map(AssortmentConfig.fromDto) : [],
      locations: dto.locations ? dto.locations.map(LocationConfig.fromDto) : [],
    });
}
